import { useState, useEffect } from 'react'
import { AvailableClient_Enum } from '../components/AcceptConditions/AcceptConditions'
import { getCitizenships, getInstanceSettings } from './useGetCityCustomHook'

interface InstanceSettings {
  translations: { name: string; language: number }[]
  availableClient: AvailableClient_Enum
}

interface FormSettingsResult {
  loading: boolean
  instanceSettings: InstanceSettings | undefined
  settingsCitizenship: { countryCode: string; isActive?: boolean }[]
}

/** Loads instance settings and active citizenships once on mount. */
export function useFormSettings(): FormSettingsResult {
  const [loading, setLoading] = useState(true)
  const [instanceSettings, setInstanceSettings] = useState<InstanceSettings>()
  const [settingsCitizenship, setSettingsCitizenship] = useState<{ countryCode: string; isActive?: boolean }[]>([])

  useEffect(() => {
    let cancelled = false
    async function init() {
      setLoading(true)
      try {
        const [settings, citizenships] = await Promise.all([
          getInstanceSettings(),
          getCitizenships(),
        ])
        if (!cancelled) {
          setInstanceSettings(settings)
          setSettingsCitizenship(citizenships)
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    init()
    return () => { cancelled = true }
  }, [])

  return { loading, instanceSettings, settingsCitizenship }
}
